export const LIMITS = {
  MAX_LEVEL_BYTES: 256 * 1024,
  WARN_LEVEL_BYTES: 200 * 1024,
  MAX_LEVELS_PER_ACCOUNT: 100,
  MAX_NAME_LEN: 60,
  MAX_DESCRIPTION_LEN: 500,
  MAX_TAGS: 6,
  PIN_ATTEMPT_LOCKOUT: 5,
  PIN_LOCKOUT_MS: 60 * 60 * 1000,
  SESSION_TTL_MS: 90 * 24 * 60 * 60 * 1000,
  SYNC_STATUS_CACHE_MS: 60 * 1000,
} as const;

export const RATE_LIMITS = {
  signup_per_ip_per_hour: 3,
  login_per_ip_per_hour: 10,
  recover_per_ip_per_hour: 10,
  name_suggestions_per_ip_per_min: 60,
  // Blanket per-account ceiling across all authed endpoints. Not yet wired — expensive
  // endpoints (push) have their own stricter per-user caps. Add a session-middleware
  // guard using this constant if future usage surfaces a need for a blanket limit.
  authed_per_user_per_min: 60,
  push_per_user_per_hour: 20,
  push_per_user_per_day: 100,
} as const;
